import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Elements } from '@stripe/react-stripe-js';
import { withTranslation } from 'react-i18next';
import {
    DaButton,
    InternalGrid,
    ModalControl,
    ModalProvider,
} from '@paygreen/paygreen-ui';
import IconByName from '../../../../utils/IconByName';
import { StatusDisplayTable } from '../../../../components';
import { stripeAccountModes } from '../../../../utils/constants';
import { stripeAccountStatusOptions, detectStripeStatus } from '../../shared';
import CharityStripeAccountModal from './CharityStripeAccountModal';
import CharityStripeValidateModal from './CharityStripeValidateModal';
import { loadStripe } from '@stripe/stripe-js/pure';

const StripeKey = process.env.REACT_APP_STRIPE_KEY;
const StripeAccountid = process.env.REACT_APP_STRIPE_ACCOUNT_ID;

const CharityStripeAccountStatus = ({
    t,
    accountData,
    setAccountData,
    refresh,
}) => {
    const [stripePromise, setStripePromise] = useState(null);

    useEffect(() => {
        const getStripeData = async () => {
            return await loadStripe(StripeKey, {
                stripeAccount: StripeAccountid,
            });
        };

        setStripePromise(getStripeData());
    }, []);

    let colorStatus = null;
    let buttonText = null;
    let icon = null;
    const stripeStatus = detectStripeStatus(
        accountData?.readyToOnboard,
        accountData?.onboardingCompleted,
        accountData?.association?.validatedAt,
    );

    switch (stripeStatus) {
        case stripeAccountModes.VALIDATED:
            colorStatus = 'default';
            icon = 'OutIcon';
            buttonText = t('form.button.open');
            break;
        case stripeAccountModes.TOVALIDATE:
            colorStatus = 'success';
            icon = 'CheckIcon';
            buttonText = t('form.button.validate');
            break;
        case stripeAccountModes.TOCREATE:
            colorStatus = 'success';
            icon = 'StartIcon';
            buttonText = t('form.button.create');
            break;
        default:
            colorStatus = 'success';
            icon = 'StartIcon';
            buttonText = t('form.button.create');
            break;
    }

    const StripeButton = () => (
        <DaButton
            buttonSize="sm"
            buttonStyle="line"
            colorPallet="status"
            colorStatus={colorStatus}
            icon={<IconByName name={icon} />}
            isDisabled={stripeStatus === stripeAccountModes.NONE}
            title={
                stripeStatus === stripeAccountModes.NONE
                    ? t('admin.charity.noCreation')
                    : ''
            }
        >
            {buttonText}
        </DaButton>
    );

    return (
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="auto auto"
            gridGap="sm"
            alignItems="center"
        >
            <StatusDisplayTable
                status={stripeStatus}
                statusOptions={stripeAccountStatusOptions}
                i18TextBase="admin.charities.table.stripeAccountStatusFilter"
            />

            {stripeStatus === stripeAccountModes.VALIDATED ? (
                <a
                    href="https://dashboard.stripe.com/connect/accounts/overview"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <StripeButton />
                </a>
            ) : (
                <>
                    <Elements stripe={stripePromise}>
                        <ModalProvider>
                            <ModalControl>
                                {stripeStatus === stripeAccountModes.NONE ? (
                                    <StripeButton />
                                ) : (
                                    <button>
                                        <StripeButton />
                                    </button>
                                )}
                            </ModalControl>

                            <ModalControl>
                                {stripeStatus ===
                                stripeAccountModes.TOVALIDATE ? (
                                    <CharityStripeValidateModal
                                        accountData={accountData}
                                        setAccountData={setAccountData}
                                        refresh={refresh}
                                    />
                                ) : (
                                    <CharityStripeAccountModal
                                        accountData={accountData}
                                        setAccountData={setAccountData}
                                    />
                                )}
                            </ModalControl>
                        </ModalProvider>
                    </Elements>
                </>
            )}
        </InternalGrid>
    );
};

CharityStripeAccountStatus.propTypes = {
    accountData: PropTypes.object,
    setAccountData: PropTypes.func,
    refresh: PropTypes.func,
};

CharityStripeAccountStatus.defaultProps = {
    accountData: {},
};

export default withTranslation('common')(CharityStripeAccountStatus);
